import { Component, effect, inject, OnDestroy, OnInit, signal } from '@angular/core';
import { ReactiveFormsModule, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { QuestionComponent } from '@app/components/shared/form/question/question.component';
import { TitleComponent } from '@app/components/title/title.component';
import { QuestionBase } from '@app/models/question-base';
import { DropDownquestion } from '@app/models/questions/question-dropdown';
import { PassWordQuestion } from '@app/models/questions/question-password';
import { BranchService } from '@app/services/branch/branch.service';
import { KioskPINService } from '@app/services/kiosk-pin/kiosk-pin.service';
import { QuestionControlService } from '@app/services/question/question-control.service';
import { BannerComponent } from "../../components/shared/banner/banner.component";
import { SchedulerStepService } from '@app/services/step/scheduler-step.service';
import { LoadingComponent } from '@app/components/global/loading/loading.component';

@Component({
  selector: 'afcu-configurations',
  standalone: true,
  providers: [QuestionControlService],
  imports: [TitleComponent, ReactiveFormsModule, QuestionComponent, BannerComponent, LoadingComponent],
  templateUrl: './configurations.component.html',
  styleUrl: './configurations.component.css'
})
export class ConfigurationsComponent implements OnDestroy {
  
  private readonly qcs = inject(QuestionControlService);
  protected branchService = inject( BranchService )
  protected schedulerService = inject( SchedulerStepService )
  private router = inject(Router)
  
  protected kioskPIN = inject( KioskPINService )
  
  questions = [this.QLocations, this.QPin]
  isLoading = false
  showCancel = true

  formSubmitted = false;

  errorPIN = false
  errorBanner = {title: 'Error: The PIN entered is invalid',content: ''} as BannerType

  errorForm = false
  form: FormGroup = this.qcs.toFormGroup(this.questions as QuestionBase<string>[]);

  ngOnDestroy(): void {
    this.kioskPIN.password.set(null)
    this.kioskPIN.error.set(false)
  }

  constructor(){
    effect(() => {
      this.isLoading = this.branchService.items().length > 0

      if (this.isLoading)
        this.questions = [this.QLocations, this.QPin]

      const selectedBranch = document.cookie
      if(!selectedBranch.includes('selectedBranch')){
        this.showCancel = false
      }
      if(!this.kioskPIN.PINRessource.isLoading() && this.kioskPIN.password() !== null) {
        if(this.kioskPIN.error())
          this.errorPIN = true
        else{
          this.errorPIN = false
          document.cookie = "selectedBranch="+this.schedulerService.branchSelected().branchID+"; Path=/"
          this.router.navigate(['/splash'], { queryParams: { origin: 'kiosk'}})
        }
      }
    })
  }

  cancel() {
    this.router.navigate(['/splash'], { queryParams: { origin: 'kiosk'}})
  }

  select(event: { function: string; value: string}){
    if(event.function == 'locationSelect'){
      if (event.value === '')
        this.schedulerService.branchSelected.set({} as Branch)
      else
        this.schedulerService.branchSelected.set(this.branchService.items().filter( branch => branch.branchID === event.value)[0])
      // this.selectedBranch.set(event.value)
      // if(event.value === ''){
      //   this.form.get('q_location')?.setErrors({ 'error': true })
      // }
      // else
      //   this.form.get('q_location')?.setErrors({})
    }
  }

  onSubmit() {

    if(this.schedulerService.branchSelected().branchID === undefined || (this.form.get('q_PIN')?.value.length === 0 || this.form.get('q_PIN')?.value.length < 6)){
      if(this.schedulerService.branchSelected().branchID === undefined)
        this.form.get('q_location')?.setErrors({ 'error': true })

      if(this.form.get('q_PIN')?.value.length === 0 || this.form.get('q_PIN')?.value.length < 6)
        this.form.get('q_PIN')?.setErrors({ 'error': true })

      this.errorForm = true
    }else{
      this.errorForm = false
    }

    if(!this.errorForm){
      this.formSubmitted = true;
      this.kioskPIN.password.set(this.form.get('q_PIN')?.value)
    }
  }
  
  get QLocations() {
    return new DropDownquestion ({
      key: 'q_location',
      externalFunction: "locationSelect",
      label: 'Set Kiosk Location',
      options: [{text: 'Select Location', value: ''} as InputOption,...this.branchService.items().map( branch => {
        return { text: branch.locationName, value:branch.branchID, selected: !!this.schedulerService.branchSelected() && this.schedulerService.branchSelected()!.branchID === branch.branchID } as InputOption 
      })],
      required: true,
      errorText: 'Error: must select a location.',
      order: 1
    })
  }

  
  get QPin() {
    return new PassWordQuestion ({
      key: 'q_PIN',
      label: 'PIN',
      placeholder: 'Enter admin PIN',
      errorText: 'Error: enter a valid PIN.',
      width: '70%',
      numberOnly: true,
      minLength:6,
      maxLength:6,
      order: 2
    })
  }
}
